<div class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
  <asw-mybooking-baggage-rules
    [data]="mybookingBaggageRulesData"
    [isPlanValid]="isPlanValid"
    (clickLinkEvent)="clickLinkEvent()"
  ></asw-mybooking-baggage-rules>
</div>
